
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Spinner from '../Spinner';
import swal from 'sweetalert2';
import { connect } from 'react-redux';

// Styles
import styles from './styles';


import api from '../../api';

/**
 *  Forgot Password Dialog Component
 */
class ForgotPasswordDialog extends Component {

  state = {
    email: '',
    submitting: false,
  };

  componentDidUpdate(prevProps, prevState) {

  }

  handleClose = () => {
    this.props.handleClose();
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  _handleSignup = () => {
    this.props.handleSignup();
  }

  _handleLogin = () => {
    this.props.handleLogin(); //  Go to login dialog
  }

  _handleForgotPassword = () => {

    const { email } = this.state;

    if(!email) {
      return this.setState({ errorText: 'Please input your email' });
    }

    // server side validation will catch this
    if(!email.includes('@')) {
      return this.setState({ errorText: 'Please input a valid email' });
    }

    this.setState({ errorText: '', submitting: true });

    // Submit forgot password
    api.forgotPassword({ name: email }).then(result => {

      console.log(result);

      this.setState({
        email: '',
        submitting: false,
      });

      this.handleClose();

      swal({
        type: 'success',
        title: 'Successfully Reset Password',
        text: 'You have been sent an email that contains a password reset link for you to reset your password',
      });

    }).catch(err => {
      console.log('err', err);
      this.setState({ errorText: err, submitting: false });
    });

  }

  _renderLoading = () => {

    const { fullScreen, classes } = this.props;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.open}
        key={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent style={styles.loadingContent}>
          <DialogContentText style={{ textAlign: 'center', marginBottom: 20 }}>
            Sending Reset Email...
          </DialogContentText>
          <Spinner loading={true}/>
        </DialogContent>
      </Dialog>
    );

  }

  render() {

    const { fullScreen, classes } = this.props;
    const { errorText, submitting } = this.state;

    // if attempting to login
    if(submitting) {
      return this._renderLoading();
    }

    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.open}
            key={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Forgot your Password?"}</DialogTitle>
        <DialogContent>

          <DialogContentText>
            Enter your email and we will send you a password reset link
          </DialogContentText>

          <TextField
            required
            id="email-forgot"
            label="Email"
            placeholder="Email"
            margin="normal"
            fullWidth
            value={this.state.email}
            onChange={this.handleChange('email')}
          />

          {/* Error Prompt */}
          <p style={styles.errorText}>{ errorText ? `**${errorText}` : '' }</p>

          {/* Alternate Options */}
          <div style={styles.alternateOptionsContainer}>

            <span
              style={{ marginTop: 10, cursor: 'pointer', color: 'rgba(0,0,0,0.5)', display: 'block' }}
              onClick={this._handleLogin}
            >Back to login</span>

          </div>

        </DialogContent>

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this._handleForgotPassword} color="primary" variant="raised">
            Submit
          </Button>
        </DialogActions>

      </Dialog>
    );
  }
}

ForgotPasswordDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

ForgotPasswordDialog = withMobileDialog()(ForgotPasswordDialog);

function mapStateToProps(state, ownProps) {
	return {

	};
}

function mapDispatchToProps(dispatch) {
	return {

	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordDialog);



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordDialog/index.js